module.exports = __webpack_public_path__ + "static/ubm-57fe21886f46e319f80e6000bc010af4.jpg";